import { IPrimaryButtonProps } from 'interfaces/GeneralType/generalTypes';

import { Spinner } from '../Spinner/Spinner';

export const PrimaryButton = (props: IPrimaryButtonProps) => {
  return (
    <div
      className={`px-6 flex items-center h-10 rounded-md bg-yellow w-[fit-content] text-black hover:cursor-pointer ${
        props.disabled && 'bg-fade hover:cursor-not-allowed'
      }`}
      onClick={() => {
        if (!props.disabled && props.onClick && !props.isLoading)
          props.onClick();
      }}
    >
      {props.isLoading ? <Spinner /> : props.children}
    </div>
  );
};
